import React from 'react';
import { AlertTriangle } from 'lucide-react';
import {
  getCancellationPolicy,
  HOW_TO_CANCEL_TR,
  HOW_TO_CANCEL_EN,
} from '../../lib/flightCancellationPolicy';

/**
 * Airtuerk iptal ceza tablosu — rezervasyon / onay sayfalarında.
 */
const FlightCancellationPolicy = ({
  airlineCode,
  compact = false,
  className = '',
}) => {
  const policy = getCancellationPolicy(airlineCode);

  if (compact) {
    return (
      <div className={`text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-3 ${className}`}>
        <p className="font-medium flex items-center gap-1.5 mb-1">
          <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
          İptal: {policy.isLowcost ? `%${policy.tiers[0].penaltyPercent} (lowcost)` : '%50–95 (kalkışa göre)'}
        </p>
        <p className="text-amber-700/90 leading-relaxed">{HOW_TO_CANCEL_TR}</p>
      </div>
    );
  }

  return (
    <div className={`rounded-lg border border-amber-200 bg-amber-50/80 p-4 ${className}`}>
      <h4 className="font-semibold text-amber-900 flex items-center gap-2 mb-2">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        İptal koşulları / Cancellation policy
      </h4>

      {policy.airlineCode && (
        <p className="text-sm text-amber-800 mb-2">
          Havayolu: <strong>{policy.airlineCode}</strong>
          {policy.isLowcost ? ' (Lowcost / AITC)' : ' (Portal / AITO)'}
          {' · '}
          <span className="text-amber-700">{policy.policyLabel}</span>
        </p>
      )}

      <p className="text-sm text-amber-900 mb-3 leading-relaxed">{HOW_TO_CANCEL_TR}</p>
      <p className="text-xs text-amber-700/80 mb-3 italic">{HOW_TO_CANCEL_EN}</p>

      <div className="overflow-x-auto rounded-md border border-amber-200/80 bg-white">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-amber-100/60 text-left">
              <th className="px-3 py-2 font-medium text-amber-900">Kalkışa kalan süre</th>
              <th className="px-3 py-2 font-medium text-amber-900 text-center w-24">Ceza</th>
            </tr>
          </thead>
          <tbody>
            {policy.tiers.map((tier, i) => (
              <tr key={i} className="border-t border-amber-100">
                <td className="px-3 py-2 text-gray-700">{tier.daysLabel}</td>
                <td className="px-3 py-2 text-center font-semibold text-amber-900">
                  %{tier.penaltyPercent}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="text-xs text-amber-800 mt-3 leading-relaxed">{policy.noteTr}</p>
    </div>
  );
};

export default FlightCancellationPolicy;
